import React, { useEffect, useState } from "react";
// import { DataGrid, GridToolbar } from '@material-ui/data-grid';
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@material-ui/data-grid";
import Grid from "@material-ui/core/Grid";
import ReportDiagloue from "./ReportDiagloue";
import Cookies from "js-cookie";

const moment = require("moment");
const { default: utils } = require("../../utils/functions");
const axios = require("axios");
const { convertToMinutes } = utils;

function getModalStyle() {
  const top = 47;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomToolbar = ({
  equipmentIDs,
  setTokenStillValid,
  currentOrganisation,
  timeStampStates,
  withinOrExceedStates,
  clearTimeStampsStates,
  listOfAlarmTypesSWAlarm,
  listOfEquipmentIDs,
  durationStates,
  dischargeStates,
  temperatureStates,
  filledLevelPercentState,
  dataType,
}) => {
  let modalWidth = 600;
  let modalHeight = 380;

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: modalWidth,
      height: modalHeight,
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #26477c",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [dropdownOpen, setDropDownOpen] = useState(false);
  const [open, setOpen] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  let {
    weightDischarged,
    setWeightDischarged,
    balancedWeight,
    setBalancedWeight,
    weightLimit,
    setWeightLimit,
  } = dischargeStates;

  let { filledLevelPercent, setFilledLevelPercent } = filledLevelPercentState;

  let { temperature, setTemperature } = temperatureStates;
  let { days, hours, minutes } = durationStates;
  let { durationDays, setDurationDays } = days;
  let { durationHours, setDurationHours } = hours;
  let { durationMinutes, setDurationMinutes } = minutes;

  let { timeStamps, setTimeStamps } = timeStampStates;
  let { clearTimeStamps, setClearTimeStamps } = clearTimeStampsStates;
  let { start: tSStart, end: tSEnd } = timeStamps;
  let { start: tSClearStart, end: tSClearEnd } = clearTimeStamps;

  let alarmType = {
    sembwaste: [
      "DischargeGateMotorTrip",
      "WeightExceedLimit",
      "GateNotClose",
      "DischargeScrewMotorTrip",
      "EStop",
      "TransferScrewMotorTrip",
      "MotorTrip",
      "FireAlarm",
      "BinLifterMotorTrip",
    ],
    ntu: ["DischargeScrewMotorTrip", "EStop"],
    zenith: [
      "DischargeGateMotorTrip",
      "WeightExceedLimit",
      "GateNotClose",
      "DischargeScrewMotorTrip",
      "EStop",
      "TransferScrewMotorTrip",
      "FireAlarm",
      "BinLifterMotorTrip",
    ],
    "800_SGbins": ["E-Stop", "FireAlarm"],
    ntuGomic: [
      "EStop",
      "FilledLevel",
      "WeightAlert",
      "BinLifterAbnormal",
      "DischargeGateNotClose",
    ],
  };

  let { EquipmentIDs, setEquipmentIDs, equipmentGroup, setEquipmentGroup } =
    listOfEquipmentIDs;
  let { alarmTypes, setAlarmTypes } = listOfAlarmTypesSWAlarm;
  let { withinOrExceed, setWithinOrExceed } = withinOrExceedStates;

  const handleClear = () => {
    setEquipmentIDs([]);
    setEquipmentGroup(null);
    let daysago = new Date();
    daysago.setDate(daysago.getDate() - 180);
    setTimeStamps({
      ...timeStamps,
      ["start"]: daysago,
      ["end"]: new Date(),
    });
    setClearTimeStamps({
      ...clearTimeStamps,
      ["start"]: daysago,
      ["end"]: new Date(),
    });
    setAlarmTypes([]);
    setFilledLevelPercent(90);
    setTemperature(50);
    setWeightDischarged(5000);
    setBalancedWeight(1000);
    setWeightLimit({
      ...weightLimit,
      ["discharge"]: "<=",
      ["balance"]: "<=",
      ["temperature"]: "<=",
      ["filledPercent"]: "<=",
    });
    setWithinOrExceed("Within");
    setDurationDays(0);
    setDurationHours(8);
    setDurationMinutes(0);
  };

  const handleFilledLevelLimit = (event) => {
    setWeightLimit({
      ...weightLimit,
      ["filledPercent"]: event.target.value,
    });
  };

  const handleTemperatureLimit = (event) => {
    setWeightLimit({
      ...weightLimit,
      ["temperature"]: event.target.value,
    });
  };

  const handleDischargeWeightLimit = (event) => {
    setWeightLimit({
      ...weightLimit,
      ["discharge"]: event.target.value,
    });
  };

  const handleBalanceWeightLimit = (event) => {
    setWeightLimit({
      ...weightLimit,
      ["balance"]: event.target.value,
    });
  };

  const handleFilledLevelPercent = (event) => {
    setFilledLevelPercent(parseInt(event.target.value));
  };

  const handleTemperature = (event) => {
    setTemperature(parseInt(event.target.value));
  };

  const handleDischargeWeight = (event) => {
    setWeightDischarged(parseInt(event.target.value));
  };

  const handleBalanceWeight = (event) => {
    setBalancedWeight(parseInt(event.target.value));
  };

  const handleSetDurationDays = (event) => {
    let days = parseInt(event.target.value);

    if (isNaN(days)) {
      setDurationDays(0);
    }

    if (days < 0) {
      setDurationDays(0);
    } else {
      setDurationDays(days);
    }
  };

  const handleSetDurationHours = (event) => {
    let hours = parseInt(event.target.value);
    if (isNaN(hours)) {
      setDurationHours(8);
    }
    if (hours >= 24) {
      setDurationHours(0);
    } else if (hours < 0) {
      setDurationHours(24);
    } else {
      setDurationHours(hours);
    }
  };

  const handleSetDurationMinutes = (event) => {
    let minutes = parseInt(event.target.value);
    if (isNaN(minutes)) {
      setDurationMinutes(0);
    }
    if (minutes >= 59) {
      setDurationMinutes(0);
    } else if (minutes < 0) {
      setDurationMinutes(59);
    } else {
      setDurationMinutes(minutes);
    }
  };

  const handleWithinOrExceed = (event) => {
    setWithinOrExceed(event.target.value);
  };

  const handleMultipleEquipmentID = (event) => {
    setEquipmentIDs(event.target.value);
  };

  const handleEquipmentGroups = (event) => {
    setEquipmentGroup(event.target.value);

    let ListOfEquipmentIDs = EquipmentIDs;
    let filteredEquipID = [];
    let equipmentGrp = event.target.value;
    if (equipmentGrp) {
      if (ListOfEquipmentIDs.length > 0) {
        for (let i = 0; i < ListOfEquipmentIDs.length; i++) {
          let equipID = ListOfEquipmentIDs[i];

          if (equipID.includes(equipmentGrp)) {
            filteredEquipID.push(equipID);
          }
        }
      }
      setEquipmentIDs(filteredEquipID);
    }
  };

  const handleMultipleAlarmTypes = (event) => {
    setAlarmTypes(event.target.value);
  };

  const handleTimeStampStart = (date) => {
    setTimeStamps({
      ...timeStamps,
      ["start"]: date,
    });
  };

  const handleTimeStampEnd = (date) => {
    setTimeStamps({
      ...timeStamps,
      ["end"]: date,
    });
  };

  const handleClearTimeStampStart = (date) => {
    setClearTimeStamps({
      ...clearTimeStamps,
      ["start"]: date,
    });
  };

  const handleClearTimeStampEnd = (date) => {
    setClearTimeStamps({
      ...clearTimeStamps,
      ["end"]: date,
    });
  };

  let alarmList = alarmType[currentOrganisation];
  alarmList = alarmList.sort();

  const handleDropDownClose = () => {
    setDropDownOpen(false);
  };

  const handleDropDownOpen = () => {
    setDropDownOpen(true);
  };

  let dateErrorMsg = <></>;

  if (tSStart > tSEnd) {
    dateErrorMsg = (
      <>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: "flex",
              justifyContent: "center",
            }}
            item
            xs={12}
          >
            <span style={{ fontSize: "1em", color: "red" }}>Invalid Date</span>
          </Grid>
        </Grid>
        <div>&nbsp;</div>
      </>
    );
  }
  return (
    <GridToolbarContainer>
      {/* <GridToolbarColumnsButton
        style={{
          fontFamily: 'Roboto',
          fontWeight: '500',
          fontSize: '0.8125rem',
          color: '#26477c',
        }}
      /> */}
      <GridToolbarFilterButton
        style={{
          fontFamily: "Roboto",
          fontWeight: "500",
          fontSize: "0.8125rem",
          color: "#26477c",
        }}
      />
      &nbsp;
      <ReportDiagloue
        setTokenStillValid={setTokenStillValid}
        getStyles={getStyles}
        theme={theme}
        alarmTypes={alarmTypes}
        alarmList={alarmList}
        handleClear={handleClear}
        handleDropDownClose={handleDropDownClose}
        handleTimeStampStart={handleTimeStampStart}
        handleTimeStampEnd={handleTimeStampEnd}
        handleClearTimeStampStart={handleClearTimeStampStart}
        handleClearTimeStampEnd={handleClearTimeStampEnd}
        handleMultipleEquipmentID={handleMultipleEquipmentID}
        handleEquipmentGroups={handleEquipmentGroups}
        handleMultipleAlarmTypes={handleMultipleAlarmTypes}
        handleWithinOrExceed={handleWithinOrExceed}
        handleSetDurationDays={handleSetDurationDays}
        handleSetDurationHours={handleSetDurationHours}
        handleSetDurationMinutes={handleSetDurationMinutes}
        handleDischargeWeight={handleDischargeWeight}
        handleBalanceWeight={handleBalanceWeight}
        handleDischargeWeightLimit={handleDischargeWeightLimit}
        handleBalanceWeightLimit={handleBalanceWeightLimit}
        handleTemperature={handleTemperature}
        handleFilledLevelPercent={handleFilledLevelPercent}
        handleTemperatureLimit={handleTemperatureLimit}
        handleFilledLevelLimit={handleFilledLevelLimit}
        classes={classes}
        EquipmentIDs={EquipmentIDs}
        equipmentGroup={equipmentGroup}
        equipmentIDs={equipmentIDs}
        dataType={dataType}
        tSStart={tSStart}
        tSEnd={tSEnd}
        tSClearStart={tSClearStart}
        tSClearEnd={tSClearEnd}
        withinOrExceed={withinOrExceed}
        durationDays={durationDays}
        durationHours={durationHours}
        durationMinutes={durationMinutes}
        weightDischarged={weightDischarged}
        weightLimit={weightLimit}
        balancedWeight={balancedWeight}
        temperature={temperature}
        filledLevelPercent={filledLevelPercent}
        MenuProps={MenuProps}
        currentOrganisation={currentOrganisation}
      />
      &nbsp;
      <GridToolbarExport
        style={{
          fontFamily: "Roboto",
          fontWeight: "500",
          fontSize: "0.8125rem",
          color: "#26477c",
        }}
      />
    </GridToolbarContainer>
  );
};

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});
const _ = require("lodash");

const Report = ({
  page,
  setTokenStillValid,
  currentOrganisation,
  dataType,
}) => {
  let daysago = new Date();
  daysago.setDate(daysago.getDate() - 180);

  const [timeStamps, setTimeStamps] = useState({
    start: daysago,
    end: new Date(),
  });

  //markVars

  const [temperature, setTemperature] = useState(50);
  const [filledLevelPercent, setFilledLevelPercent] = useState(90);

  const [withinOrExceed, setWithinOrExceed] = useState("Within");
  const [durationDays, setDurationDays] = useState(0);
  const [durationHours, setDurationHours] = useState(8);
  const [durationMinutes, setDurationMinutes] = useState(0);

  const [weightDischarged, setWeightDischarged] = useState(5000);
  const [balancedWeight, setBalancedWeight] = useState(5000);
  const [equipmentGroup, setEquipmentGroup] = useState(null);

  const [weightLimit, setWeightLimit] = useState({
    discharge: "<=",
    balance: "<=",
    temperature: "<=",
    filledPercent: "<=",
  });

  const [clearTimeStamps, setClearTimeStamps] = useState({
    start: daysago,
    end: new Date(),
  });

  const [alarmTypes, setAlarmTypes] = useState([]);
  const [EquipmentIDs, setEquipmentIDs] = useState([]);
  const [reportData, getReportData] = useState(false);
  const [reportDataFields, setreportDataFields] = useState(false);

  useEffect(() => {
    let authObj = Cookies.get("authObj");
    let token;
    if (authObj) {
      authObj = JSON.parse(authObj);
      token = authObj["token"];
    }
    let apiKeys = {
      admin: "jnjirej9reinvuiriuerhuinui",
      serviceUser: "juit959fjji44jcion4moij0kc",
    };
    let renderReportType;
    switch (page) {
      case "Alarm Report":
        renderReportType = "Alarm";
        break;
      case "Loadcell and Capacity Record Report":
        renderReportType = "Other";
        break;
      default:
      // code block
    }

    if (!reportData) {
      let config = {
        headers: { Authorization: `Bearer ${token}`, apikey: apiKeys["admin"] },
      };

      axios
        .get(
          `${process.env.REACT_APP_API}/getReportAndEquipmentData/${currentOrganisation}/true/${renderReportType}`,
          config
        )
        .then((response) => {
          // console.log(response);
          getReportData(response.data.result);
          console.log(response.data.result);
        })
        .catch(function (error) {
          console.log(error);
        });
    }

    if (!reportDataFields) {
      let config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      axios
        .get(`${process.env.REACT_APP_API}/getReportFields`, config)
        .then((response) => {
          setreportDataFields(response.data.result);
        })
        .catch(function (error) {});
    }
  });

  let dataLoaded =
    currentOrganisation && reportData && reportDataFields && dataType;
  dataLoaded = dataLoaded && reportData[currentOrganisation];
  if (dataLoaded) {
    let [jsonFields] = reportDataFields.filter((field) => {
      if (field.organisation === currentOrganisation) {
        return field;
      }
    });

    let [equipmentData] = reportData[currentOrganisation];
    equipmentData = equipmentData["Equipment"]["equipmentInformation"];

    let equipmentIDs = equipmentData.map((equip) => equip.EquipmentID);

    if (equipmentGroup) {
      equipmentIDs = equipmentIDs.filter((ids) => ids.includes(equipmentGroup));
    }
    equipmentIDs = equipmentIDs.sort();

    let stateObj = {};
    equipmentIDs.forEach((ids) => {
      stateObj[ids] = false;
    });
    jsonFields = jsonFields["reportInformation"][dataType]["ReportFields"];
    let headerFields = jsonFields["renderedFields"];
    let dataFields = jsonFields["dbfields"];
    let columns = [
      {
        editable: false,
        hide: true,
        headerName: "#",
        field: "id",
        width: 100,
      },
    ];

    for (let i = 0; i < dataFields.length; i++) {
      let datafield = dataFields[i];
      let headerField = headerFields[i];
      let columnEl = {
        editable: false,
        hide: false,
      };

      columnEl["headerName"] = headerField;
      columnEl["field"] = datafield;

      switch (datafield) {
        case "ts":
          if (columnEl["headerName"] === "TimeStamp") {
            columnEl["width"] = 200;
          } else {
            columnEl["width"] = 280;
          }
          columnEl["type"] = "date";
          break;
        case "address":
          columnEl["width"] = 280;
          break;
        case "TimeStamp":
          columnEl["width"] = 200;
          break;
        case "rfid_id":
          columnEl["width"] = 200;
          break;
        case "vendorName":
          columnEl["width"] = 170;
          break;
        case "ID":
          columnEl["width"] = 180;
          break;
        case "EquipmentID":
          columnEl["width"] = 180;
          break;
        case "equipmentID":
          columnEl["width"] = 180;
          break;
        case "deviceId":
          columnEl["width"] = 180;
          break;
        case "Temperature":
          columnEl["width"] = 200;
          break;
        case "ID":
          columnEl["width"] = 180;
          break;
        case "ClearedTS":
          columnEl["width"] = 280;
          columnEl["type"] = "date";
          break;
        case "timeDifference":
          columnEl["width"] = 280;
          break;
        case "EquipmentType":
          columnEl["width"] = 200;
          break;
        case "Type":
          columnEl["width"] = 230;
          break;
        case "type":
          columnEl["width"] = 180;
          break;
        case "Status":
          columnEl["width"] = 160;
          break;
        case "shortAddress":
          columnEl["width"] = 160;
          break;
        case "collectedWeight":
          columnEl["width"] = 230;
          break;
        case "collectTS":
          columnEl["width"] = 230;
          columnEl["type"] = "date";
          break;
        case "currentWeight":
          columnEl["width"] = 210;
          break;
        case "FilledLevelWeight":
          columnEl["width"] = 210;
          break;
        case "weight":
          columnEl["width"] = 210;
          break;
        case "WeightPercentage":
          columnEl["width"] = 210;
          break;
        default:
          console.log(columnEl);
      }
      columns.push(columnEl);
    }

    let [organisationReportData] = reportData[currentOrganisation];
    organisationReportData = organisationReportData[dataType];

    if (dataType == "Other") {
      organisationReportData = organisationReportData["data"];
    }

    for (let i = 0; i < organisationReportData.length; i++) {
      let report = organisationReportData[i];
      organisationReportData[i]["id"] = i + 1;
      if (organisationReportData[i]["currentWeight"]) {
        if (organisationReportData[i]["currentWeight"] < 0) {
          organisationReportData[i]["currentWeight"] = 0;
        } else {
          organisationReportData[i]["currentWeight"] = Math.round(
            organisationReportData[i]["currentWeight"]
          );
        }
      }

      if (currentOrganisation === "ntuGomic") {
        if (!report.vendorName) {
          organisationReportData[i]["vendorName"] = `<Discharge>`;
        }

        if (!report.rfid_id) {
          organisationReportData[i]["rfid_id"] = `-`;
        }
      }
    }

    let sorting;

    switch (currentOrganisation) {
      case "sembwaste":
        if (dataType === "Alarm") {
          sorting = [
            {
              field: "ts",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.ts;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.ts > start && data.ts < end) {
                  return data;
                }
              }
            });
          }

          let { start: clearStart, end: clearEnd } = timeStamps;
          clearStart = moment(clearStart).format();
          [clearStart] = clearStart.split("T");
          clearEnd = moment(clearEnd).format();
          [clearEnd] = clearEnd.split("T");
          clearEnd = `${clearEnd} 23:59:59`;
          if (clearStart <= clearEnd) {
            organisationReportData = organisationReportData.filter((data) => {
              if (clearStart === clearEnd) {
                let dataTimeStamp = data.ClearedTS;
                if (dataTimeStamp.startsWith(clearStart)) {
                  return data;
                }
              } else {
                if (data.ClearedTS > start && data.ClearedTS < clearEnd) {
                  return data;
                }
              }
            });
          }

          let orgReport = [];

          let noOfMinutes = convertToMinutes(
            durationDays,
            durationHours,
            durationMinutes
          );

          if (withinOrExceed === "Within") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes <= noOfMinutes) {
                orgReport.push(data);
              }
            });
          } else if (withinOrExceed === "Exceed") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes >= noOfMinutes) {
                orgReport.push(data);
              }
            });
          }

          organisationReportData = orgReport;

          orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.EquipmentID;
              if (ids.includes(equipmentGroup)) {
                return data;
              }
            });
          }
          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.EquipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }

          let alarmOrgReport = [];
          if (alarmTypes.length > 0) {
            organisationReportData.forEach((data) => {
              alarmTypes.forEach((alarmTyp) => {
                if (data.Type === alarmTyp) {
                  alarmOrgReport.push(data);
                }
              });
            });
          }
          if (alarmOrgReport.length > 0) {
            organisationReportData = alarmOrgReport;
            alarmOrgReport = undefined;
          }
        }
        if (dataType === "Weight") {
          sorting = [
            {
              field: "collectTS",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.collectTS;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.collectTS > start && data.collectTS < end) {
                  return data;
                }
              }
            });
          }
          let balanceWeightLimit = weightLimit.balance;
          switch (balanceWeightLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight === balancedWeight
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight !== balancedWeight
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight > balancedWeight
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight >= balancedWeight
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight < balancedWeight
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight <= balancedWeight
              );
              break;
            default:
            // code block
          }

          let dischargeWeightLimit = weightLimit.discharge;
          switch (dischargeWeightLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight === weightDischarged
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight !== weightDischarged
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight > weightDischarged
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight >= weightDischarged
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight < weightDischarged
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight <= weightDischarged
              );
              break;
            default:
            // code block
          }

          let orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.EquipmentID;
              if (ids.includes(equipmentGroup)) {
                return data;
              }
            });
          }
          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.EquipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }
        }
        break;
      case "zenith":
        if (dataType === "Weight") {
          sorting = [
            {
              field: "collectTS",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.collectTS;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.collectTS > start && data.collectTS < end) {
                  return data;
                }
              }
            });
          }

          let balanceWeightLimit = weightLimit.balance;
          switch (balanceWeightLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight === balancedWeight
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight !== balancedWeight
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight > balancedWeight
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight >= balancedWeight
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight < balancedWeight
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data.currentWeight <= balancedWeight
              );
              break;
            default:
            // code block
          }

          let dischargeWeightLimit = weightLimit.discharge;
          switch (dischargeWeightLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight === weightDischarged
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight !== weightDischarged
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight > weightDischarged
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight >= weightDischarged
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight < weightDischarged
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data.collectedWeight <= weightDischarged
              );
              break;
            default:
            // code block
          }

          let orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.EquipmentID;
              if (ids.includes(equipmentGroup)) {
                return data;
              }
            });
          }
          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.EquipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }
        }
        break;
      case "ntu":
        if (dataType === "Other") {
          sorting = [
            {
              field: "ts",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.ts;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.ts > start && data.ts < end) {
                  return data;
                }
              }
            });
          }

          let temperatureLimit = weightLimit.temperature;
          switch (temperatureLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] === temperature
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] !== temperature
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] > temperature
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] >= temperature
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] < temperature
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data["Temperature"] <= temperature
              );
              break;
            default:
            // code block
          }

          let filledPercentLimit = weightLimit.filledPercent;

          switch (filledPercentLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] === filledLevelPercent
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] !== filledLevelPercent
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] > filledLevelPercent
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] >= filledLevelPercent
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] < filledLevelPercent
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => data["FilledLevelWeight"] <= filledLevelPercent
              );
              break;
            default:
            // code block
          }

          let orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.ID;
              if (ids.includes(equipmentGroup)) {
                return data;
              }
            });
          }

          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.ID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }
        }
        break;
      case "800_SGbins":
        if (dataType === "Alarm") {
          sorting = [
            {
              field: "ts",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.ts;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.ts > start && data.ts < end) {
                  return data;
                }
              }
            });
          }

          let { start: clearStart, end: clearEnd } = timeStamps;
          clearStart = moment(clearStart).format();
          [clearStart] = clearStart.split("T");
          clearEnd = moment(clearEnd).format();
          [clearEnd] = clearEnd.split("T");
          clearEnd = `${clearEnd} 23:59:59`;
          if (clearStart <= clearEnd) {
            organisationReportData = organisationReportData.filter((data) => {
              if (clearStart === clearEnd) {
                let dataTimeStamp = data.ClearedTS;
                if (dataTimeStamp.startsWith(clearStart)) {
                  return data;
                }
              } else {
                if (data.ClearedTS >= start && data.ClearedTS <= clearEnd) {
                  return data;
                }
              }
            });
          }

          let orgReport = [];

          let noOfMinutes = convertToMinutes(
            durationDays,
            durationHours,
            durationMinutes
          );

          if (withinOrExceed === "Within") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes <= noOfMinutes) {
                orgReport.push(data);
              }
            });
          } else if (withinOrExceed === "Exceed") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes >= noOfMinutes) {
                orgReport.push(data);
              }
            });
          }

          organisationReportData = orgReport;

          orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.EquipmentID;
              if (ids.startsWith(equipmentGroup)) {
                return data;
              }
            });
            if (equipmentGroup === "IZSGB-B") {
              organisationReportData = organisationReportData.filter((data) => {
                let ids = data.EquipmentID;
                if (!ids.startsWith("IZSGB-BHD")) {
                  return data;
                }
              });
            }
          }
          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.EquipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }

          let alarmOrgReport = [];
          if (alarmTypes.length > 0) {
            organisationReportData.forEach((data) => {
              alarmTypes.forEach((alarmTyp) => {
                if (data.Type === alarmTyp) {
                  alarmOrgReport.push(data);
                }
              });
            });
          }
          if (alarmOrgReport.length > 0) {
            organisationReportData = alarmOrgReport;
            alarmOrgReport = undefined;
          }
        }

        if (dataType === "Other") {
          sorting = [
            {
              field: "ts",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;
          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.ts;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.ts > start && data.ts < end) {
                  return data;
                }
              }
            });
          }

          let filledPercentLimit = weightLimit.filledPercent;
          switch (filledPercentLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) ===
                  parseInt(filledLevelPercent)
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) !==
                  parseInt(filledLevelPercent)
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) >
                  parseInt(filledLevelPercent)
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) >=
                  parseInt(filledLevelPercent)
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) <
                  parseInt(filledLevelPercent)
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) =>
                  parseInt(data["WeightPercentage"]) <=
                  parseInt(filledLevelPercent)
              );
              break;
            default:
            // code block
          }

          let balanceWeightLimit = weightLimit.balance;
          switch (balanceWeightLimit) {
            case "=":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) === parseInt(balancedWeight)
              );
              break;
            case "!=":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) !== parseInt(balancedWeight)
              );
              break;
            case ">":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) > parseInt(balancedWeight)
              );
              break;
            case ">=":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) >= parseInt(balancedWeight)
              );
              break;
            case "<":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) < parseInt(balancedWeight)
              );
              break;
            case "<=":
              organisationReportData = organisationReportData.filter(
                (data) => parseInt(data.weight) <= parseInt(balancedWeight)
              );
              break;
            default:
            // code block
          }

          let orgReport = [];
          if (equipmentGroup) {
            organisationReportData = organisationReportData.filter((data) => {
              let ids = data.deviceId;
              if (ids.startsWith(equipmentGroup)) {
                return data;
              }
            });
            if (equipmentGroup === "IZSGB-B") {
              organisationReportData = organisationReportData.filter((data) => {
                let ids = data.deviceId;
                if (!ids.startsWith("IZSGB-BHD")) {
                  return data;
                }
              });
            }
          }

          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.deviceId === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }
        }
        break;
      case "ntuGomic":
        if (dataType === "Alarm") {
          //convert timestamp for gomic

          sorting = [
            {
              field: "ts",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;

          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.ts;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.ts > start && data.ts < end) {
                  return data;
                }
              }
            });
          }

          let { start: clearStart, end: clearEnd } = timeStamps;
          clearStart = moment(clearStart).format();
          [clearStart] = clearStart.split("T");
          clearEnd = moment(clearEnd).format();
          [clearEnd] = clearEnd.split("T");
          clearEnd = `${clearEnd} 23:59:59`;
          if (clearStart <= clearEnd) {
            organisationReportData = organisationReportData.filter((data) => {
              if (clearStart === clearEnd) {
                let dataTimeStamp = data.ClearedTS;
                if (dataTimeStamp.startsWith(clearStart)) {
                  return data;
                }
              } else {
                if (data.ClearedTS >= start && data.ClearedTS <= clearEnd) {
                  return data;
                }
              }
            });
          }

          let orgReport = [];

          let noOfMinutes = convertToMinutes(
            durationDays,
            durationHours,
            durationMinutes
          );

          if (withinOrExceed === "Within") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes <= noOfMinutes) {
                orgReport.push(data);
              }
            });
          } else if (withinOrExceed === "Exceed") {
            organisationReportData.forEach((data) => {
              if (data.timeDifferenceInMinutes >= noOfMinutes) {
                orgReport.push(data);
              }
            });
          }

          organisationReportData = orgReport;

          orgReport = [];

          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.EquipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }

          let alarmOrgReport = [];
          if (alarmTypes.length > 0) {
            organisationReportData.forEach((data) => {
              alarmTypes.forEach((alarmTyp) => {
                if (data.Type === alarmTyp) {
                  alarmOrgReport.push(data);
                }
              });
            });
          }
          if (alarmOrgReport.length > 0) {
            organisationReportData = alarmOrgReport;
            alarmOrgReport = undefined;
          }

          for (let i = 0; i < organisationReportData.length; i++) {
            let reportData = organisationReportData[i];
            let { ClearedTS, ts } = reportData;

            const convertTS = (parsedOrg) => {
              let [date, time] = parsedOrg.split(" ");
              let [year, month, day] = date.split("-");

              let ts = `${day}-${month}-${year} ${time}`;
              return ts;
            };
            organisationReportData[i]["convertedClearedTS"] =
              convertTS(ClearedTS);
            organisationReportData[i]["convertedTS"] = convertTS(ts);
          }

          let convertedTSIndex = 0;
          let convertedClearedTS = 0;

          for (let i = 0; i < columns.length; i++) {
            let column = columns[i];
            let { field } = column;
            if (field && field === "ts") {
              convertedTSIndex = i + 1;
            }
            if (field && field === "ClearedTS") {
              convertedClearedTS = i + 1;
            }
          }

          columns.splice(convertedTSIndex, 0, {
            editable: false,
            field: "convertedTS",
            headerName: "Alarm Trigger Timestamp",
            hide: false,
            width: 250,
          });

          columns.splice(convertedClearedTS, 0, {
            editable: false,
            field: "convertedClearedTS",
            headerName: "Alarm Clear Timestamp",
            hide: false,
            width: 250,
          });

          columns[convertedTSIndex - 1]["hide"] = true;
          columns[convertedClearedTS + 1]["hide"] = true;

          // let newColumn = columns.map((column) => {
          //   console.log(column.field);
          //   if (column.field === "ts") {
          //     column["field"] = "convertedTS";
          //   }
          //   return column;
          // });

          console.log(convertedTSIndex);
        }

        if (dataType === "Other") {
          sorting = [
            {
              field: "TimeStamp",
              sort: "desc",
            },
          ];
          let { start, end } = timeStamps;
          start = moment(start).format();
          [start] = start.split("T");
          end = moment(end).format();
          [end] = end.split("T");
          end = `${end} 23:59:59`;

          if (start <= end) {
            organisationReportData = organisationReportData.filter((data) => {
              if (start === end) {
                let dataTimeStamp = data.TimeStamp;
                if (dataTimeStamp.startsWith(start)) {
                  return data;
                }
              } else {
                if (data.TimeStamp > start && data.TimeStamp < end) {
                  return data;
                }
              }
            });
          }

          // if()

          // let filledPercentLimit = weightLimit.filledPercent;
          // switch (filledPercentLimit) {
          //   case "=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) ===
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   case "!=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) !==
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   case ">":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) >
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   case ">=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) >=
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   case "<":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) <
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   case "<=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) =>
          //         parseInt(data["WeightPercentage"]) <=
          //         parseInt(filledLevelPercent)
          //     );
          //     break;
          //   default:
          //   // code block
          // }

          // let balanceWeightLimit = weightLimit.balance;
          // switch (balanceWeightLimit) {
          //   case "=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) === parseInt(balancedWeight)
          //     );
          //     break;
          //   case "!=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) !== parseInt(balancedWeight)
          //     );
          //     break;
          //   case ">":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) > parseInt(balancedWeight)
          //     );
          //     break;
          //   case ">=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) >= parseInt(balancedWeight)
          //     );
          //     break;
          //   case "<":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) < parseInt(balancedWeight)
          //     );
          //     break;
          //   case "<=":
          //     organisationReportData = organisationReportData.filter(
          //       (data) => parseInt(data.weight) <= parseInt(balancedWeight)
          //     );
          //     break;
          //   default:
          //   // code block
          // }

          let orgReport = [];

          if (EquipmentIDs.length > 0) {
            organisationReportData.forEach((data) => {
              EquipmentIDs.forEach((ids) => {
                if (data.equipmentID === ids) {
                  orgReport.push(data);
                }
              });
            });
          }

          if (orgReport.length > 0 || EquipmentIDs.length > 0) {
            organisationReportData = orgReport;
            orgReport = undefined;
          }
          for (let i = 0; i < organisationReportData.length; i++) {
            let reportData = organisationReportData[i];
            let { TimeStamp } = reportData;
            const convertTS = (parsedOrg) => {
              let [date, time] = parsedOrg.split(" ");
              let [year, month, day] = date.split("-");

              let ts = `${day}-${month}-${year} ${time}`;
              return ts;
            };
            organisationReportData[i]["convertedTS"] = convertTS(TimeStamp);
          }
          let convertedTSIndex = 0;

          for (let i = 0; i < columns.length; i++) {
            let column = columns[i];
            let { field } = column;
            if (field && field === "TimeStamp") {
              convertedTSIndex = i + 1;
            }
          }

          columns.splice(convertedTSIndex, 0, {
            editable: false,
            field: "convertedTS",
            headerName: "Timestamp",
            hide: false,
            width: 250,
          });

          columns[convertedTSIndex - 1]["hide"] = true;
        }
        break;
      default:
      // code block
    }

    //mark
    // const [filledLevelPercent, setFilledLevelPercent] = useState(50);

    let datagridData = { columns: columns, rows: organisationReportData };
    return (
      <div style={{ height: 620 }}>
        <ThemeProvider theme={theme}>
          <DataGrid
            {...datagridData}
            // loading={true}
            components={{
              Toolbar: CustomToolbar,
            }}
            componentsProps={{
              toolbar: {
                stateObj: stateObj,
                equipmentIDs: equipmentIDs,
                setTokenStillValid: setTokenStillValid,
                currentOrganisation: currentOrganisation,
                withinOrExceedStates: {
                  withinOrExceed: withinOrExceed,
                  setWithinOrExceed: setWithinOrExceed,
                },
                filledLevelPercentState: {
                  filledLevelPercent: filledLevelPercent,
                  setFilledLevelPercent: setFilledLevelPercent,
                },
                temperatureStates: {
                  temperature: temperature,
                  setTemperature: setTemperature,
                },
                dischargeStates: {
                  weightDischarged: weightDischarged,
                  setWeightDischarged: setWeightDischarged,
                  balancedWeight: balancedWeight,
                  setBalancedWeight: setBalancedWeight,
                  weightLimit: weightLimit,
                  setWeightLimit: setWeightLimit,
                },
                durationStates: {
                  days: {
                    durationDays: durationDays,
                    setDurationDays: setDurationDays,
                  },
                  hours: {
                    durationHours: durationHours,
                    setDurationHours: setDurationHours,
                  },
                  minutes: {
                    durationMinutes: durationMinutes,
                    setDurationMinutes: setDurationMinutes,
                  },
                },
                timeStampStates: {
                  timeStamps: timeStamps,
                  setTimeStamps: setTimeStamps,
                },
                clearTimeStampsStates: {
                  clearTimeStamps: clearTimeStamps,
                  setClearTimeStamps: setClearTimeStamps,
                },
                listOfAlarmTypesSWAlarm: {
                  alarmTypes: alarmTypes,
                  setAlarmTypes: setAlarmTypes,
                },
                listOfEquipmentIDs: {
                  EquipmentIDs: EquipmentIDs,
                  setEquipmentIDs: setEquipmentIDs,
                  equipmentGroup: equipmentGroup,
                  setEquipmentGroup: setEquipmentGroup,
                },
                dataType: dataType,
              },
            }}
            sortModel={sorting}
            filterModel={{
              items: [
                // {
                //   columnField: 'commodity',
                //   operatorValue: 'contains',
                //   value: 'rice',
                // },
              ],
            }}
          />
        </ThemeProvider>
      </div>
    );
  } else {
    return <div>Loading Report Data...</div>;
  }
};

export default Report;
